var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "customers" }, [
        _c("div", [
          _c("p", { staticClass: "today-year-month" }, [
            _vm._v(
              _vm._s(_vm.todayYear) + "年 " + _vm._s(_vm.todayMonth) + "月"
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "avatar" }, [
          _c("img", {
            attrs: {
              src: _vm.avatarImg,
              width: "571",
              height: "684",
              loding: "lazy"
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "float-right" }, [
          _c("div", { staticClass: "customers-text-box" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !this.bodyWeightAlert,
                    expression: "!this.bodyWeightAlert"
                  }
                ],
                staticClass: "monitoring-alert body-weight-alert"
              },
              [
                _c("img", {
                  attrs: { src: require("@/assets/home/アセット 26@2x.png") }
                })
              ]
            ),
            _vm._v(" "),
            _c("p", { staticClass: "customers-text text-base" }, [
              _vm._v("体重")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "color-bule result-value" }, [
              _vm._v(_vm._s(this.hearingsLatest.weight))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "customers-text text-unit" }, [_vm._v("kg")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "customers-text-box" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !this.stretchAlert,
                    expression: "!this.stretchAlert"
                  }
                ],
                staticClass: "monitoring-alert stretch-alert"
              },
              [
                _c("img", {
                  attrs: { src: require("@/assets/home/アセット 26@2x.png") }
                })
              ]
            ),
            _vm._v(" "),
            _c("p", { staticClass: "customers-text text-base" }, [
              _vm._v("屈伸")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "color-bule result-value" }, [
              _vm._v(_vm._s(this.hearingsLatest.stretch))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "customers-text text-unit" }, [_vm._v("回")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "customers-text-box" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !this.healthCheckAlert,
                    expression: "!this.healthCheckAlert"
                  }
                ],
                staticClass: "monitoring-alert health-check-alert"
              },
              [
                _c("img", {
                  attrs: { src: require("@/assets/home/アセット 26@2x.png") }
                })
              ]
            ),
            _vm._v(" "),
            _c("p", { staticClass: "customers-text text-base" }, [
              _vm._v("健康チェック")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "color-bule result-value" }, [
              _vm._v(_vm._s(this.hearingsLatest.number_checked))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "customers-text text-unit" }, [_vm._v("点")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "clear" })
      ]),
      _vm._v(" "),
      _vm.hearingsLatestDialog
        ? _c("FrailCheckAlert", { on: { "home-back": _vm.closeAlert } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c952b43e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c952b43e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserInformation.vue
// module id = null
// module chunks = 